module.exports = __webpack_public_path__ + "img/card_login.dc6dd418.png";